import { css } from "@emotion/react";
import { COLUMN_SPACING } from "../../../../forms/styles";
import { Column } from "../../../../layout/flexbox";
import { HistoricalRedemption } from "../historicalRedemption"
import { getResource } from "../../../../language/resources/getResource";
import { BigNeutral } from "../../../../forms/elements/buttons";
import LabelGroup from "../../../../forms/elements/LabelGroup";
import { useSelector } from "react-redux";
import { IAppState } from "../../../../core/redux/IAppState";
import { getRedemptionType, MAX_CORRECTION_NOTE_LENGTH } from "../module";
import { Input } from "../../../../forms/elements/Input";
import { isNilOrEmpty } from "../../../../language/module";
import { ColumnConfig } from "../../../../layout/table/columnConfig";
import { RedemptionType } from "../redemptionType";
import { formatDate } from "../../../../language/time";
import Table from "../../../../layout/table/Table";
import { QuickEntitlement } from "../../models";
import { getDescription, getSeason } from "../../module";
import ImmutableMap from "../../../../language/ImmutableMap";
import { EntitlementType } from "../../../../entitlementTypes/entitlementType";


const onNoteChange = onChange => event => onChange(event.target.value);

type Props = {
    redemptions: Set<HistoricalRedemption>
    redemptionTypes?: RedemptionType[];
    onSave: () => void,
    note?: string,
    onNoteChange: (note: string) => void;
    targetEntitlement: QuickEntitlement | undefined,
    sourceEntitlement: QuickEntitlement | undefined,
    isMigration: boolean,
    allEntitlementTypes: ImmutableMap<EntitlementType>;
}

export const PassUsageCorrectionModal = (props: Props) => {
    const resources = useSelector((state: IAppState) => state.locale);
    const dateFormat = useSelector((state: IAppState) => state.defaultDateFormat);
    

    const columnConfig: Array<ColumnConfig<HistoricalRedemption>> = [
        { id: 1, title: getResource(resources, 'VIEW_DAYS_TAB_COLUMN_REDEMPTION_ID')},
        { id: 2, title: getResource(resources, 'VIEW_DAYS_TAB_COLUMN_TYPE')},
        {
          id: 3, 
          title:                   getResource(resources, 'VIEW_DAYS_TAB_COLUMN_DATE'),
          defaultSortingColumn:    true,
          defaultSortingDirection: 'desc',
        },
        { id: 4, title: getResource(resources, 'VIEW_DAYS_TAB_COLUMN_RESORT'),},
        { id: 5, title: getResource(resources, 'VIEW_DAYS_TAB_COLUMN_MODIFIED_BY')},
        { id: 6, title: getResource(resources, 'VIEW_DAYS_TAB_COLUMN_DAYS_USED')},
        { id: 7, title: getResource(resources, 'VIEW_DAYS_TAB_COLUMN_NOTES')},
      
      ];

      const renderRow = (
          redemption: HistoricalRedemption,
          typeList: RedemptionType[] | undefined,
          migration: boolean
        ): React.ReactNode =>(
          <tr key={redemption.redemptionID}>
            <td css={css`width: 150px;`}>{redemption.redemptionID}</td>
            <td>{ typeList ? getRedemptionType(typeList, redemption.redemptionTypeId) : redemption.redemptionTypeId }</td>
            <td css={css`width: 130px;`}>{formatDate(redemption.redeemDate, dateFormat)}</td>
            <td>{redemption.redeemResort} - {redemption.redeemLocation}</td>
            <td>{redemption.modifiedById}</td>
            {migration && <td css={css`width: 60px; text-align: right;`}>{redemption.redeemQuantity}</td>}
            {!migration && <td css={css`width: 60px; text-align: right;`}>{redemption.redeemQuantity * -1}</td>}
            <td css={css`max-width: 600px; word-wrap: break-word; hyphens: auto;`}>{redemption.redemptionExternalCode}</td>
          </tr>
        );

        const renderRowWithTypes = (redemption: HistoricalRedemption) => {
            return renderRow(redemption, props.redemptionTypes, false);
        };
        
        const renderRowNewEntitlement = (redemption: HistoricalRedemption) => {
            return renderRow(redemption, props.redemptionTypes, true);
        };

    return (
        <Column rootCss={css`${COLUMN_SPACING};`}>
            <span css={css`font-size: 18px;`}>{getResource(resources, 'DAY_CORRECTION_DIRECTION')}</span>

            <span>{getSeason(props.sourceEntitlement, props.allEntitlementTypes) 
            + " " + getDescription(props.sourceEntitlement, props.allEntitlementTypes)}</span>

            <Table columns={columnConfig}
                         data={Array.from(props.redemptions) || []}
                         isLoading={false}
                         noDataMessage={getResource(resources, 'VIEW_DAYS_NO_DATA')}
                         renderRow={renderRowWithTypes}/>

            {props.isMigration && 
                    <span>{getSeason(props.targetEntitlement, props.allEntitlementTypes) 
                    + " " + getDescription(props.targetEntitlement, props.allEntitlementTypes)}</span>}
            {props.isMigration && 
                <Table columns={columnConfig}
                    data={Array.from(props.redemptions) || []}
                    isLoading={false}
                    noDataMessage={getResource(resources, 'VIEW_DAYS_NO_DATA')}
                    renderRow={renderRowNewEntitlement}
                    />
            }

            <span>{getResource(resources, 'DAY_CORRECTION_INFO')}</span>

            <LabelGroup label={getResource(resources, 'DAY_CORRECTION_NOTE_LABEL')}>
            <Input title={getResource(resources, 'DAY_CORRECTION_INPUT')}
                    maxLength={MAX_CORRECTION_NOTE_LENGTH}
                    type='text'
                    autoFocus={true}
                    value={props.note}
                    onChange={onNoteChange(props.onNoteChange)}
                    placeholder={getResource(resources, 'DAY_CORRECTION_INPUT_PLACEHOLDER')}
                    css={css`flex-grow: 1;`}/>
            </LabelGroup>

            <BigNeutral title={props.isMigration ? getResource(resources, 'PASS_MIGRATION_BUTTON_TITLE') : getResource(resources, 'PASS_CORRECTION_BUTTON_TITLE')}
                        onClick={props.onSave}
                        disabled={isNilOrEmpty(props.note)}
                        style={{ alignSelf: 'flex-end' }}>
                        {props.isMigration ? getResource(resources, 'PASS_MIGRATION_BUTTON_TITLE') : getResource(resources, 'PASS_CORRECTION_BUTTON_TITLE')}
            </BigNeutral>
        </Column>
    );
}